// @ts-nocheck
import { type FC } from 'react';

import JoRelatedCard from '@core/blocks/jo-v1/components/JoRelatedCard';
import SponsoredResultsPopover from '@core/shared/components/SponsoredResultsPopover';
import type { VoyagerResult, VoyagerResultEnhancedSchoolData } from '@core/ts/results';
import cn from '@core/utils/classNames';

import RecommenderCard from '../../features/JoRecommender/ProgramSelect/RecommenderCard';
// import  from '../Card';
import styles from './ResultsList.module.css';

type Props = {
  header: string;
  subheader: string;
  results: VoyagerResult[];
  borrowedResults?: VoyagerResult[] | null;
  showUgToGradResultsPageABTest?: boolean;
  isRelatedResults?: boolean;
};
const ResultsList: FC<Props> = ({
  header,
  subheader,
  results,
  isRelatedResults = false,
  borrowedResults,
  showUgToGradResultsPageABTest,
}) => (
  <div className={styles.matchListContainer}>
    <div className={styles.matchListContainerInner}>
      <div className={styles.matchListHeader}>
        <h2>{header}</h2>

        <div className={styles.sponsored}>
          <SponsoredResultsPopover />
        </div>
      </div>

      <p className={styles.matchListSubheader}>{subheader}</p>
      <div className={styles.sponsoredMobile}>
        <SponsoredResultsPopover />
      </div>

      <div
        className={cn(
          !isRelatedResults ? styles.resultsGrid : styles.relatedResultsLayout,
          showUgToGradResultsPageABTest ? styles.threeColumns : styles.twoColums
        )}
      >
        {results?.map((result, index) =>
          !isRelatedResults ? (
            <RecommenderCard
              key={result.program.id}
              result={result}
              eventingOverrides={{
                location: 'voyager-results-page',
                customDimensions: [
                  {
                    key: 'isUserRequested',
                    value: 'false',
                  },
                ],
              }}
              position={index + 1}
              layout="column-reverse"
              withTopBorder
              fullWidth
              onRecommender={false}
            />
          ) : (
            <JoRelatedCard
              key={result.program.id}
              result={result}
              eventingOverrides={{
                location: 'voyager-results-page',
                customDimensions: [
                  {
                    key: 'isUserRequested',
                    value: 'false',
                  },
                ],
              }}
              position={index + 1}
              fullWidth
            />
          )
        )}
        {borrowedResults?.map((result, index) => (
          <RecommenderCard
            key={result.program.id}
            result={result}
            eventingOverrides={{
              location: 'voyager-results-page',
              customDimensions: [
                {
                  key: 'isUserRequested',
                  value: 'false',
                },
              ],
            }}
            position={index + 1}
            layout="column-reverse"
            withTopBorder
            fullWidth
            onRecommender={false}
          />
        ))}
      </div>
    </div>
  </div>
);

ResultsList.defaultProps = {
  borrowedResults: null,
};
export default ResultsList;
